import { ComponentCollection } from 'survey-core';
import { useClientFormQuestions } from './useClientFormQuestions';
import { usePatientFormQuestions } from './usePatientFormQuestions';
import { useHtmlTemplateQuestions } from './useHtmlTemplateQuestions';
import { Species, ClientForm } from '../api/types/digitalForms.api.types';

// Track if question types have been registered
let questionTypesRegistered = false;

export const useRegisterCustomQuestionTypes = ({ species, clientForm }: { species: Species[]; clientForm?: ClientForm }) => {
  const { clientQuestions } = useClientFormQuestions();
  const { patientQuestions } = usePatientFormQuestions({ species });
  const { htmlTemplateQuestions } = useHtmlTemplateQuestions({ clientForm });

  if (!questionTypesRegistered) {
    questionTypesRegistered = true;
    const allQuestions = [...clientQuestions, ...patientQuestions, ...htmlTemplateQuestions];
    allQuestions.forEach((config) => {
      ComponentCollection.Instance.add(config);
    });
  }

  return {
    isReady: true,
  };
};
